import type { Card } from "@amzn/ads-blink-client";
import type { AsyncStatus } from "@react-hookz/web";
import type { Dispatch, SetStateAction } from "react";
import { useEffect } from "react";

import { initialUnifiedFilterState } from "../../../../config/filters/unified";
import { useUnifiedContentsLoader } from "../../../../hooks/unifiedContent/useUnifiedContentsLoader";
import { isSuccess } from "../../../../utils/api.utils";
import { withInsightsRenderer } from "../withInsightsRenderer";

import { UnifiedContentCard } from "./UnifiedContentCard";

interface UnifiedContentsProps {
    isLoaderInView: boolean;
    setAsyncStatus: Dispatch<SetStateAction<AsyncStatus>>;
    setTotalCount: Dispatch<SetStateAction<number>>;
}

export const UnifiedContents: React.FunctionComponent<UnifiedContentsProps> = (
    props: UnifiedContentsProps,
) => {
    const { isLoaderInView, setAsyncStatus, setTotalCount } = props;
    const [asyncStatus, lazyLoadedInsights, totalResults] =
        useUnifiedContentsLoader({
            isLoaderInView,
        });

    useEffect(() => {
        setAsyncStatus(asyncStatus);
    }, [asyncStatus]);

    useEffect(() => {
        if (isSuccess(asyncStatus)) {
            setTotalCount(totalResults);
        }
    }, [asyncStatus, totalResults]);

    const getCardForContentV2 = (content: Card, index: number) => {
        const filterConfig =
            initialUnifiedFilterState.filters.UNIFIED_TYPE.find(
                (filter) => filter.id === content.header,
            );
        const tag = filterConfig?.tag?.label;
        return (
            <UnifiedContentCard
                key={index}
                content={content}
                index={index}
                tag={tag}
            />
        );
    };

    return (
        <>
            {lazyLoadedInsights.map(getCardForContentV2)}
            {asyncStatus === "error" && <div>Failed to load contents</div>}
        </>
    );
};

export const UnifiedContentsViewer = withInsightsRenderer(UnifiedContents, {
    showSearchSortDropdown: true,
});
